import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter , Spinner,Progress} from 'reactstrap';
import axios from "axios";
import { t } from 'i18next';
import './style.css';
import { BACKEND_URL_DOC } from "../../config/const.js";
const ReadingList = ({ openReadingList, onCloseReadingList , startDate , endDate , groupId , type ,typeDoc, teamArray }) => {
    const [readingList, setReadingList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    
   
useEffect(() => {
     
     if (openReadingList) {
        fetchReadingList();
        }
    }, [openReadingList]);

   
    const fetchReadingList = async () => { 
        setLoading(true);
        setError(null);
        try {
            const config = {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              };
              
            const response = await axios.post(BACKEND_URL_DOC+ "getDocsStatisticsDetails", {
                startDate,
                endDate,
                clientId: groupId,
                type,
                typeFilter:typeDoc.value,
                teamArray: teamArray || ""
            },config);
            setReadingList(response);
        } catch (error) {
            setError("Erreur lors de la récupération des ReadingList");
            console.error("Erreur API:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={openReadingList} centered size="lg" >
            <ModalHeader className="detail-header" style={{ width: '100%' }}>
                <div className="modal-header-content">
                <span className="modal-title">
                {type === 'completed' ? t("read") :  t("notRead")}
                </span>
                    <Button className="cancel-btn" onClick={onCloseReadingList}>
                        {t('CLOSE')}
                    </Button>
                </div>
            </ModalHeader>
            <ModalBody className="modal-body-custom">
                {loading ? (
                    <div className="text-center mt-5">
                                <Spinner
                               color="primary"
                               style={{
                                 height: '3rem',
                                 width: '3rem'
                               }}
                             >
                               Loading...
                                </Spinner>
                                <div className="text-center mt-2">
                              {t("loading...")}
                              </div>
                              </div>
                ) : error ? (
                    <p style={{ color: "red" }}>{error}</p>
                ) : readingList && readingList.length > 0 ? (  // Vérification supplémentaire
                    <div className="log-container">
                        <table className="log-table">
                            <thead> 
                                <tr>
                                    <th>{t("readingList")}</th>
                                    <th>{t("user")}</th>
                                    <th>{t("Progression")}</th>
                                </tr>
                            </thead>
                            <tbody  style={{ color: 'black' }}>
                                {readingList.map((rea, index) => (
                                    <tr key={index} className="row-doc" >
                                        <td>{rea.title || t("Log sans titre")}</td>
                                        <td>{rea.username}</td>
                                        <td>
                                           <div style={{textAlign:"center"}}>{`${rea.progression}%`}</div>
                                        <Progress
                                        animated
                                        striped
                                        style={{textAlign:"center", color: 'black'}}
                                        value={rea.progression}
                                        >
                                            
                                        </Progress>
                                        </td>
                                        
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="text-center text-muted">{t('NoreadingList')}</p>
                )}
            </ModalBody>
        </Modal>
    );
};

export default ReadingList;
